module.exports = __webpack_public_path__ + "static/media/s10 — kopia.ae0ac5f1.jpg";